import React, { useState } from 'react';
import { MetricsElement } from "react-metrics";

import ProductPriceV2 from './product-price/product-price-v2';
import Link from '@hpstellar/core/Link';
import Button from '@hpstellar/core/Button';

import {getProductClickMetrics} from '../../metrics/metrics-helpers';

import '../css/cross-sell-product-card.less';

const CrossSellProductCard = ({ product, ctaText, addToCart, crossSellMethod, width, customCTA, className, position }) => {
    const { name, images, ksps=[], attributes={} } = product;
    const { prdOverview } = attributes;

    const [success, setSuccess] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const productDetail = prdOverview ? prdOverview : ksps.length > 0 ? ksps.join(', ') : '';

    const addAccyToCart = () => {
        addToCart(product, 1, false, undefined, undefined, product.sku, crossSellMethod, { list: crossSellMethod }).then(() => {
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false)
            }, 2000)
        })
    }

    const Details = ({ detail, visibility }) => {
        return (
            <div className={`detail-wrapper${visibility ? ' visible' : ''}`}>
                <p>{detail}</p>
                <MetricsElement>
                    <Link href={product.linkUrl} target='_blank' {...getProductClickMetrics({ product, list: 'pdp-cross-sell', position, useAttributes: true }) || {}}>Learn More</Link>
                </MetricsElement>
            </div>
        )
    }

    return (
        <div className={`cross-sell-prd-card${className ? ' ' + className : ''}`}>
            <div onMouseEnter={() => setShowDetail(true)}
                 onMouseLeave={() => setShowDetail(false)}
                 className='hover-wrapper'
            >
                <Details 
                    visibility={showDetail} 
                    detail={productDetail}
                    width={width}
                />
                <img src={images[0].lrg} />
            </div>
            <h3 onMouseEnter={() => setShowDetail(true)} onMouseLeave={() => setShowDetail(false)}>{name}</h3>
            { width <= 768 && 
                <Link 
                    icon='angle'
                    className='mobile-show-detail'
                    onClick={() => setShowDetail(!showDetail)}
                >
                    {showDetail ? 'Show less' : 'Show more'}
                </Link> }
            <ProductPriceV2
                product={product}
                className='cross-sell-card-price'
                displayDifference={true} 
                style={width > 768 ? 'left' : 'center'}
                size='medium'
            />
            { customCTA ? customCTA : 
                <Button 
                    color='dark' 
                    className='cross-sell-pc-cta'
                    disabled={product.instock === false}
                    icon='add'
                    size='small'
                    success={success}
                    onClick={addAccyToCart}
                >
                    { ctaText ? ctaText : product.instock === false ? 'out of stock' : 'add to cart'}
                </Button>
            }
        </div>
    )
}

export default CrossSellProductCard;